export default {
  init() {
    function getProvinceFromCookie() {
      const name = 'mpf-province=';
      const cDecoded = decodeURIComponent(document.cookie);
      const cArr = cDecoded.split('; ');
      let res = '';
      cArr.forEach((val) => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
      });
      return res;
    }
    var provCookie = getProvinceFromCookie();
    if (provCookie === 'QC' || provCookie === '') document.body.classList.add('quebec');
    else document.body.classList.add('ontario');
    if (provCookie === '') {
      document.getElementById('provpop-fullscreen-grey').style.display = 'block';
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
      document.getElementById('provpop-btn-quebec').addEventListener('click', function () {
        setProvince('QC');
        document.getElementById('provpop-fullscreen-grey').style.display = 'none';
        document.getElementsByTagName('body')[0].style.overflow = 'scroll';
      });
      document.getElementById('provpop-btn-ontario').addEventListener('click', function () {
        setProvince('ON');
      });
    }

    document.getElementById('provpop-topbar-switch').addEventListener('change', function () {
      setProvince(document.getElementById('provpop-topbar-switch').value);
    });
    document.getElementById('provpop-mobile-switch').addEventListener('change', function () {
      setProvince(document.getElementById('provpop-mobile-switch').value);
    });

    function setProvince(province) {
      let date = new Date();
      date.setTime(date.getTime() + 2592000000);
      document.cookie = 'mpf-province=' + province + '; expires=' + date.toUTCString() + '; path=/';
      if ((provCookie == '' && province === 'ON') || (provCookie !== province && provCookie !== '')) {
        if (window.location.pathname.match(/^\/en(.*)/) === null && province === 'ON') {
          window.location.href = window.location.protocol + '//' + window.location.host + '/en' + window.location.pathname + window.location.search;
        } else {
          location.reload();
        }
      } else provCookie = 'QC';
    }
  }
};
